import { render, staticRenderFns } from "./comTerm16.vue?vue&type=template&id=59ac80e0&scoped=true&"
import script from "./comTerm16.vue?vue&type=script&lang=js&"
export * from "./comTerm16.vue?vue&type=script&lang=js&"
import style0 from "./comTerm16.vue?vue&type=style&index=0&id=59ac80e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ac80e0",
  null
  
)

export default component.exports